import React from "react";
import { LanguageCode, translations } from "../../utils/translations";

import HeroSection from "./HeroSection";
import Capabilities from "./Capabilities";
import AutomationPlatform from "./AutomationPlatform";
import Playbooks from "./Playbooks";
import FinalCTA from "./FinalCTA";

import CustomerReviews from "../../sections/CustomerReviews";
import ContactPage from "../../sections/ContactPage";
import EndToEndBand from "../services/EndToEndBand";

interface HomePageProps {
  lang: LanguageCode;
}

/**
 * Lean, scroll-driven home page (6 sections).
 * Horizontal scrolling is used so social media AND automation
 * get equal, uncluttered space.
 */
const HomePage: React.FC<HomePageProps> = ({ lang }) => {
  const t = translations[lang];

  return (
    <>
      {/* 1. Hero */}
      <HeroSection lang={lang} />

      {/* 2. Capabilities — horizontal scroll (Social Media + Automation) */}
      <Capabilities lang={lang} />

      {/* 3. How it works — horizontal scroll */}
      <AutomationPlatform lang={lang} />

      {/* 4. Real flows / playbooks — horizontal scroll */}
      <Playbooks lang={lang} />

      {/* Slim end-to-end hint (not a full section) */}
      <EndToEndBand lang={lang} />

      {/* 5. Social proof */}
      <CustomerReviews lang={lang} />

      {/* 6. Get started (CTA + contact form) */}
      <FinalCTA lang={lang} />
      <div id="contact">
        <ContactPage content={t.contact} />
      </div>
    </>
  );
};

export default HomePage;
